import { patchUser } from "./preferences"

export type Appearance = "light" | "dark" | "system"
// The accent (data-theme on <html>). Emerald is the brand default; every
// accent is a design-system `user-accent-*` value (see entrypoints/application.css).
export type ThemeName = "emerald" | "teal" | "blue" | "slate" | "amber"

export const DEFAULT_THEME: ThemeName = "emerald"

export const APPEARANCE_KEY = "mektebi.appearance"
export const THEME_KEY = "mektebi.theme"

export const APPEARANCES: { value: Appearance; label: string }[] = [
  { value: "light", label: "Light" },
  { value: "dark", label: "Dark" },
  { value: "system", label: "System" },
]

// `swatch` is the DS user-accent colour used for the dot in the picker.
export const THEMES: { value: ThemeName; label: string; swatch: string }[] = [
  { value: "emerald", label: "Emerald", swatch: "#087a2e" },
  { value: "teal", label: "Teal", swatch: "#0e7172" },
  { value: "blue", label: "Blue", swatch: "#1d5fa8" },
  { value: "slate", label: "Slate", swatch: "#475467" },
  { value: "amber", label: "Amber", swatch: "#9a4a00" },
]

function prefersDark() {
  return (
    typeof window !== "undefined" &&
    window.matchMedia("(prefers-color-scheme: dark)").matches
  )
}

export function applyAppearance(appearance: Appearance) {
  if (typeof document === "undefined") return
  const dark = appearance === "dark" || (appearance === "system" && prefersDark())
  document.documentElement.classList.toggle("dark", dark)
}

export function applyTheme(theme: ThemeName) {
  if (typeof document === "undefined") return
  document.documentElement.setAttribute("data-theme", theme)
}

export function readAppearance(): Appearance {
  try {
    const value = localStorage.getItem(APPEARANCE_KEY)
    if (value === "light" || value === "dark" || value === "system") return value
  } catch {
    // ignore
  }
  return "system"
}

export function readTheme(): ThemeName {
  try {
    const value = localStorage.getItem(THEME_KEY)
    if (THEMES.some((t) => t.value === value)) return value as ThemeName
  } catch {
    // ignore
  }
  return DEFAULT_THEME
}

// Persist to the signed-in user's preferences (user.theme / user.color_theme).
// Fire-and-forget; localStorage + the FOUC script keep the UI instant.
export function persistAppearance(appearance: Appearance) {
  // user.theme stores "" for "system".
  patchUser({ theme: appearance === "system" ? "" : appearance })
}

export function persistTheme(theme: ThemeName) {
  patchUser({ color_theme: theme })
}
